

































import Vue, { VueConstructor } from "vue";
import MainColumns from "@/components/templates/MainColumns.vue";
import VaButton from "@/components/atoms/VaButton.vue";
import Notifications from "@/components/organisms/Notifications.vue";
import VaCard from "@/components/molecules/VaCard.vue";
import validationMixin from "@/components/mixins/validationMixin";
import dataTableMixin, {
  DataTableMixin,
} from "@/components/mixins/dataTableMixin";
import ReceiversService from "@/services/receiversService";
import i18n from "@/i18n";

export default (Vue as VueConstructor<DataTableMixin>).extend({
  name: "SignageMedia",
  mixins: [validationMixin, dataTableMixin],
  components: {
    VaCard,
    MainColumns,
    VaButton,
    Notifications,
  },
  data() {
    return {
      code: this.$route.params?.id || "",
      loading: false,
    };
  },
  methods: {
    onInput() {
      this.code = this.code.toUpperCase();
    },
    async onActivate() {
      try {
        this.loading = true;
        await ReceiversService.activate(this.code);
      } catch (error) {
        this.$store.commit("notifications/displayNotification", {
          message: i18n.t("stage.error_activating_receiver"),
          type: "error",
        });
      } finally {
        this.loading = false;
      }
    },
  },
});
